import React, { useState, useMemo } from "react";
import "./FacesheetNotes.scss";
import { LoadingBar } from "../LoadingComponents/LoadingBar";
import { getFriendlyDateFormatWithUtcTime } from "../../services/dateFormatter";
import "./MiniFacesheetNotes.scss";

export const NoteItem = ({ userDisplayName, created, body, lengthToTruncate }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const truncatedBody = useMemo(() => {
        if (isExpanded) {
            return body;
        } else {
            if (body.length > lengthToTruncate) {
                return body.substr(0, lengthToTruncate) + "...";
            } else {
                return body;
            }
        }
    }, [body, isExpanded]);

    const bodyWithHtml = useMemo(() => truncatedBody?.replace(/\n/g, "<br />"), [truncatedBody]);
    return (
        <div className="note-item">
            <div className="note-header">
                <div className="note-user">
                    <h4>{userDisplayName}</h4>
                </div>
                <div className="note-created">
                    <h6>{getFriendlyDateFormatWithUtcTime(created)}</h6>
                </div>
            </div>
            <div className="note-body">
                <p dangerouslySetInnerHTML={{ __html: bodyWithHtml }} />
                {body.length > lengthToTruncate && (
                    <a onClick={() => setIsExpanded(!isExpanded)} href="javascript:void(0)">
                        {isExpanded ? "View Less" : "View More"}
                    </a>
                )}
            </div>
        </div>
    );
};

export const MiniFacesheetNotes = ({ notes = [], isNotesLoading, onNoteAdded, lengthToTruncate = 500 }) => {
    return (
        <div className="mini-facesheet-notes">
            <LoadingBar isLoading={isNotesLoading}>
                {notes.map((x, i) => (
                    <NoteItem {...x} key={`mini_facesheet_notes_${i}`} lengthToTruncate={lengthToTruncate} />
                ))}
                {notes.length === 0 && <p className="no-notes-found">No notes found.</p>}
            </LoadingBar>
        </div>
    );
};
